import React from "react";
import "./userEngagement.css";

import SideNav from "../Components/sideNav";
import Navbar from "../Components/navbar";
import StatCards from "../Components/statCards";
import SmallMultiBar from "./smallMultiBar";
import CustomerTable from "./customerTable";
import UnderChartCustom from "./underChartCustom";
import CustomMultiTable from "./customMultiTable";

const UserEngagement = () => {
  const statCardData = [
    {
      body: "12000",
      head: "Total Users",
      icon: "./images/PvxDashboard/StatCard/UsersBlue.svg",
    },
    {
      body: "2000",
      head: "Active Users",
      icon: "./images/PvxDashboard/StatCard/Users.svg",
    },
    {
      body: "3000",
      head: "Retention Rate",
      icon: "./images/PvxDashboard/StatCard/Retention.svg",
    },
    {
      body: "1000",
      head: "Feature Adoption",
      icon: "./images/PvxDashboard/StatCard/Adoption.svg",
    },
    {
      body: "4000",
      head: "Average Session",
      icon: "./images/PvxDashboard/StatCard/AvgSession.svg",
    },
  ];

  return (
    <div className="pvxUserEngagementColor">
      <Navbar />
      <SideNav active="Engagement" />
      <div className="pvxUserEngagement">
        <StatCards statCardData={statCardData} />
        <div className="b2">
          <SmallMultiBar title="Users" dropdown={true} />
          <UnderChartCustom title="User Activity" dropdown={true} />
        </div>
        <div className="b2">
          <CustomMultiTable title="User Details" />
        </div>
        <div className="b2">
          <CustomerTable title="Projects Saved" />
        </div>
      </div>
    </div>
  );
};

export default UserEngagement;
